import {Components} from '@mui/material';
import {Colors} from '@constants/colors.constants';

const chip: Components = {
  MuiChip: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: Colors.white,
        color: Colors.text,
      },
      colorSecondary: {
        backgroundColor: Colors.background,
        color: Colors.text,
      },
      sizeSmall: {
        borderRadius: 8,
        fontSize: 16,
        fontWeight: 400,
        height: 25,
        padding: '0 3px',
      },
      deleteIconColorPrimary: {
        color: Colors.textWithOpacity,
      },
      deleteIconColorSecondary: {
        color: Colors.textWithOpacity,
      },
    },
  },
};

export default chip;
